import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconFormSeal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormSeal"><G ClipPath="url(#clip0_14456_27884)"><Path d="M15.4141 4H20V8.58594L23.4141 12L20 15.4141V20.0713H15.4072L12 23.3975L8.58496 20.0635L4 19.9824V15.4141L0.585938 12L4 8.58594V4H8.58594L12 0.585938L15.4141 4Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_14456_27884"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconFormSeal;
